import { render, staticRenderFns } from "./ClaimDetail.vue?vue&type=template&id=e1089536&scoped=true"
import script from "./ClaimDetail.vue?vue&type=script&lang=ts"
export * from "./ClaimDetail.vue?vue&type=script&lang=ts"
import style0 from "./ClaimDetail.vue?vue&type=style&index=0&id=e1089536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1089536",
  null
  
)

export default component.exports